import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BrandMark from './BrandMark';

const Footer: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer mt-auto">
      <Container>
        <Row className="gy-4">
          {/* Brand Column */}
          <Col lg={4} md={12} className="footer-brand-col">
            <div className="app-brand footer__brand mb-3">
              <span className="app-brand__mark"><BrandMark /></span>
              <span>StockHunt</span>
            </div>
            <p className="text-muted small lh-lg">
              Empowering you to hunt, track, and master your financial portfolio with real-time analytics, 
              live market indices, and transaction-aware XIRR performance calculations.
            </p>
          </Col>

          {/* Platform Links */}
          <Col lg={2} md={4} sm={6} xs={6}>
            <h6 className="fw-bold mb-3 text-dark text-uppercase tracking-wider small">Platform</h6>
            <ul className="list-unstyled footer-links">
              <li className="mb-2">
                <Link to="/" className="text-muted text-decoration-none small-hover">Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/help" className="text-muted text-decoration-none small-hover">Help Center</Link>
              </li>
              {isAuthenticated ? (
                <>
                  <li className="mb-2">
                    <Link to="/dashboard" className="text-muted text-decoration-none small-hover">Dashboard</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/portfolio" className="text-muted text-decoration-none small-hover">Portfolio</Link>
                  </li>
                </>
              ) : (
                <li className="mb-2">
                  <Link to="/login" className="text-muted text-decoration-none small-hover">Login</Link>
                </li>
              )}
            </ul>
          </Col>

          {/* Assets Columns */}
          <Col lg={2} md={4} sm={6} xs={6}>
            <h6 className="fw-bold mb-3 text-dark text-uppercase tracking-wider small">Assets</h6>
            <ul className="list-unstyled footer-links">
              {isAuthenticated && (
                <>
                  <li className="mb-2">
                    <Link to="/stocks" className="text-muted text-decoration-none small-hover">Equities</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/mutual-funds" className="text-muted text-decoration-none small-hover">Mutual Funds</Link>
                  </li>
                </>
              )}
              <li className="mb-2">
                <a href="https://www.amfiindia.com/" target="_blank" rel="noreferrer" className="text-muted text-decoration-none small-hover">AMFI India</a>
              </li>
              <li className="mb-2">
                <a href="https://finance.yahoo.com" target="_blank" rel="noreferrer" className="text-muted text-decoration-none small-hover">Yahoo Finance</a>
              </li>
            </ul>
          </Col>

          {/* Resources Column */}
          <Col lg={4} md={4} sm={12}>
            <h6 className="fw-bold mb-3 text-dark text-uppercase tracking-wider small">Disclaimer</h6>
            <p className="text-muted extra-small lh-base mb-0">
              StockHunt is a personal portfolio monitoring utility. Live market data, stock valuations, and mutual fund NAVs 
              are fetched via public AMFI and Yahoo Finance API integrations and may be subject to latency. 
              Always cross-reference calculations with your official broker ledger before making actual investment decisions.
            </p>
          </Col>
        </Row>

        <hr className="my-4 text-muted opacity-25" />

        {/* Copyright and Legal Strip */}
        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start mb-2 mb-md-0">
            <span className="text-muted small">&copy; {currentYear} StockHunt. All rights reserved.</span>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <ul className="list-inline mb-0 footer-sub-links">
              <li className="list-inline-item me-3">
                <a href="/privacy" className="text-muted text-decoration-none small">Privacy Policy</a>
              </li>
              <li className="list-inline-item me-3">
                <a href="/terms" className="text-muted text-decoration-none small">Terms of Service</a>
              </li>
              <li className="list-inline-item">
                <a href="/security" className="text-muted text-decoration-none small">Security</a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
